import {NgModule} from '@angular/core';
import {EmptyOrNoAccessComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {IconComponentModule} from 'app/components/ui/icon/item.module';
import {ToggleComponentModule} from 'app/components/form/toggle/item.module';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    IconComponentModule,
    ToggleComponentModule
  ],
  exports: [
    EmptyOrNoAccessComponent
  ],
  declarations: [EmptyOrNoAccessComponent],
  providers: [],
})
export class EmptyOrNoAccessComponentModule {
}
